import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';

const condition = (loc) =>
    loc.includes('popup') || loc.includes('/orion-vacatures/');

export const UseScrollToTop = () => {
    const location = useLocation();
    const [previousLocation, setPreviousLocation] = useState(location.pathname);

    useEffect(() => {
        setPreviousLocation(location.pathname);

        if (condition(location.pathname)) return;
        if (condition(previousLocation)) return;

        window.scrollTo(0, 0);
        setTimeout(() => {
            window.scrollTo(0, 0);
        }, 100);
    }, [location]);
};
